import React from 'react';

export const ShowingContext = React.createContext<boolean>(false);
export const TestIdContext = React.createContext<string | undefined>(undefined);
